import { Suspense } from 'react';
import { CircularProgress } from '@mui/material'

import ViewTimelineIcon from '@mui/icons-material/ViewTimeline'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import PaidIcon from '@mui/icons-material/Paid'
import GavelIcon from '@mui/icons-material/Gavel'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import FeedIcon from '@mui/icons-material/Feed'
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned'
import DescriptionIcon from '@mui/icons-material/Description'
import HandshakeIcon from '@mui/icons-material/Handshake'
import DownloadIcon from '@mui/icons-material/Download'
import RequestPageIcon from '@mui/icons-material/RequestPage'
import ChecklistIcon from '@mui/icons-material/Checklist'
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation'
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import ContactPhoneIcon from '@mui/icons-material/ContactPhone'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import HelpIcon from '@mui/icons-material/Help'
import AttachEmailIcon from '@mui/icons-material/AttachEmail'
import InputIcon from '@mui/icons-material/Input'
import DateRangeIcon from '@mui/icons-material/DateRange'
import TodayIcon from '@mui/icons-material/Today'
import WorkIcon from '@mui/icons-material/Work'

import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import SubjectIcon from '@mui/icons-material/Subject'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import AttachEmailOutlinedIcon from '@mui/icons-material/AttachEmailOutlined'
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined'
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease'
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'

export default ({icon, onClick, ...rest}: {icon: string, onClick?: () => void}) => {

    return (
        <Suspense fallback={<CircularProgress />}>
            {icon === "ViewTimelineIcon" ? <ViewTimelineIcon onClick={onClick} {...rest} /> :
             icon === "CalendarMonthIcon" ? <CalendarMonthIcon onClick={onClick} {...rest} /> :
             icon === "AttachMoneyIcon" ? <AttachMoneyIcon onClick={onClick} {...rest} /> :
             icon === "ArrowDropDownIcon" ? <ArrowDropDownIcon onClick={onClick} {...rest} /> :
             icon === "PaidIcon" ? <PaidIcon onClick={onClick} {...rest} /> :
             icon === "GavelIcon" ? <GavelIcon onClick={onClick} {...rest} /> :
             icon === "DisabledByDefaultIcon" ? <DisabledByDefaultIcon onClick={onClick} {...rest} /> :
             icon === "DoDisturbIcon" ? <DoDisturbIcon onClick={onClick} {...rest} /> :
             icon === "FeedIcon" ? <FeedIcon onClick={onClick} {...rest} /> :
             icon === "DescriptionIcon" ? <DescriptionIcon onClick={onClick} {...rest} /> :
             icon === "HandshakeIcon" ? <HandshakeIcon onClick={onClick} {...rest} /> :
             icon === "AssignmentReturnedIcon" ? <AssignmentReturnedIcon onClick={onClick} {...rest} /> :
             icon === "RequestPageIcon" ? <RequestPageIcon onClick={onClick} {...rest} /> :
             icon === "ChecklistIcon" ? <ChecklistIcon onClick={onClick} {...rest} /> :
             icon === "MedicalInformationIcon" ? <MedicalInformationIcon onClick={onClick} {...rest} /> :
             icon === "FolderSpecialIcon" ? <FolderSpecialIcon onClick={onClick} {...rest} /> :
             icon === "AssignmentTurnedInIcon" ? <AssignmentTurnedInIcon onClick={onClick} {...rest} /> :
             icon === "TaskAltIcon" ? <TaskAltIcon onClick={onClick} {...rest} /> :
             icon === "ContactPhoneIcon" ? <ContactPhoneIcon onClick={onClick} {...rest} /> :
             icon === "ContactMailIcon" ? <ContactMailIcon onClick={onClick} {...rest} /> :
             icon === "Download" ? <DownloadIcon onClick={onClick} {...rest} /> :
             icon === "ReceiptLongIcon" ? <ReceiptLongIcon onClick={onClick} {...rest} /> :
             icon === "UploadFileIcon" ? <UploadFileIcon onClick={onClick} {...rest} /> :
             icon === "FormatIndentDecreaseIcon" ? <FormatIndentDecreaseIcon onClick={onClick} {...rest} /> :
             icon === "FormatIndentIncreaseIcon" ? <FormatIndentIncreaseIcon onClick={onClick} {...rest} /> :
             icon === "HelpIcon" ? <HelpIcon onClick={onClick} {...rest} />:
             icon === "AttachEmailIcon" ? <AttachEmailIcon onClick={onClick} {...rest} /> :
             icon === "InputIcon" ? <InputIcon onClick={onClick} {...rest} /> :
             icon === "DateRangeIcon" ? <DateRangeIcon onClick={onClick} {...rest} /> :
             icon === "TodayIcon" ? <TodayIcon onClick={onClick} {...rest} /> :
             icon === "WorkIcon" ? <WorkIcon onClick={onClick} {...rest} /> :
             icon === "FolderOpenIcon" ? <FolderOpenIcon onClick={onClick} {...rest} /> :
             icon === "SubjectIcon" ? <SubjectIcon onClick={onClick} {...rest} /> :
             icon === "InsertDriveFileOutlinedIcon" ? <InsertDriveFileOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "DeleteOutlineOutlinedIcon" ? <DeleteOutlineOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "EditNoteOutlinedIcon" ? <EditNoteOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "FileDownloadOutlinedIcon" ? <FileDownloadOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "AttachEmailOutlinedIcon" ? <AttachEmailOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "DrawOutlinedIcon" ? <DrawOutlinedIcon onClick={onClick} {...rest} /> :
             icon === "LocalHospitalIcon" ? <LocalHospitalIcon onClick={onClick} {...rest} /> :
                <div>Unknown icon: {icon}</div>}
        </Suspense>
    )
}